import type { ApiResponse } from '@abaninja/types';

import { httpClient } from '@abaninja/util-http-client';
import { createCancellablePromise } from '@abaninja/util-store';

import type { Me, MePatchData } from './@types';

export function getMe() {
  return createCancellablePromise(({ signal }) => httpClient.get<ApiResponse<Me>>('/users/v1/me', { signal }));
}

export function patchMe(data: MePatchData) {
  return httpClient.patch<ApiResponse<Me>>('/users/v1/me', data);
}
